import React from 'react';

import { Box } from '@nerdwallet/currency';

// Local components
import { Browser } from '../../../types';
import MonthlyResults from '../../config-builder-free/monthly-results';
import RateTableCta from '../../rate-table-cta/rate-table-cta';

import ACBreakdown from './ac-breakdown';
import { Data } from './types';

interface ACResultsPanelProps {
  browser: Browser;
  data?: Data;
}

const ACResultsPanel: React.FC<ACResultsPanelProps> = ({ browser, data }) => {
  const total = data?.outputs?.monthlyPayments?.mortgage;
  const loanTerm = data?.inputs?.loanTerm;
  return (
    <div className="ac-results-panel">
      <Box
        marginX="3"
        paddingTop={{ desktop: 5, mobile: 3 }}
        marginBottom={{ desktop: 4, mobile: 0 }}
        borderBottom={{ desktop: 0, mobile: 2 }}
      >
        <MonthlyResults
          total={total}
          loanTerm={loanTerm}
          headerText="Monthly principal &amp; interest"
          calculatorNameForSegment="mortgage_amortization_calculator"
        />
      </Box>
      <Box marginX="3">
        <ACBreakdown browser={browser} data={data} />
        <RateTableCta trackingFormName="ac" data={data} />
      </Box>
    </div>
  );
};

ACResultsPanel.displayName = 'ACResultsPanel';

export default ACResultsPanel;
